import {useRef} from "react";

import {useFrame, useThree} from "@react-three/fiber";

const BUTTON_RELATIVE_SCALE = 20; // Relative scale based on screen size

export const useButtonScale = () => {
  const {camera} = useThree(); // Access canvas size and camera
  const buttonScale = useRef(BUTTON_RELATIVE_SCALE);

  useFrame(() => {
    const newButtonScale = BUTTON_RELATIVE_SCALE / camera.zoom;
    if (newButtonScale != buttonScale.current) {
      buttonScale.current = newButtonScale;
    }
  });

  return {
    buttonScale,
  };
};
